import { keyBy } from 'lodash'
import { isEmpty } from 'lodash'
import axios from 'axios'
import { i18n } from '@/ic-common/i18n/i18n-setup'

const _ = { keyBy, isEmpty }

var countries = {}

const getCountries = function() {
  return new Promise((resolve, reject) => {
    if (_.isEmpty(countries)) {
      axios
        .get((window.outsidemodx?"assets/country/"+`${i18n.locale}.json`:process.env.MIX_IC_AJAX_ROOT + `/js/country/${i18n.locale}.json`))
        .then(res => {
          countries = res.data
          resolve(countries)
        })
    } else {
      resolve(countries)
    }
  })
}


export { getCountries, countries }

